import { ModuleWithProviders, NgModule } from '@angular/core';

import { DataService } from './data.service';
import { DocumentService } from './document.service';
import { InvoiceService } from './invoice.service';
import { PatientFolderService } from './patientFolder.service';
import { PubsubService } from './pubsub.service';
import { QuotationService } from './quotation.service';
import { UploadService } from './upload.service';

@NgModule({})
export class ServicesModule {
  static forRoot(): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: [
        DataService,
        DocumentService,
        InvoiceService,
        PatientFolderService,
        PubsubService,
        QuotationService,
        UploadService,
      ],
    };
  }
}
